import axios from 'axios';

// Same-origin by default (works on any domain the app is deployed to).
// Only set REACT_APP_BACKEND_URL if the API lives on a different origin
// (cross-origin dev setups).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  getMe: () => api.get('/auth/me'),
  register: (email, password, role) => api.post('/auth/register', { email, password, role }),
};

export const articlesAPI = {
  list: (params) => api.get('/articles', { params }),
  count: (params) => api.get('/articles/count', { params }),
  get: (id) => api.get(`/articles/${id}`),
  getBySlug: (slug) => api.get(`/articles/slug/${slug}`),
  create: (data) => api.post('/articles', data),
  update: (id, data) => api.put(`/articles/${id}`, data),
  delete: (id) => api.delete(`/articles/${id}`),
  trackView: (id) => api.post(`/articles/${id}/view`),
};

export const usersAPI = {
  list: () => api.get('/users'),
  delete: (id) => api.delete(`/users/${id}`),
};

export const categoriesAPI = {
  list: () => api.get('/categories'),
  create: (data) => api.post('/categories', data),
  delete: (id) => api.delete(`/categories/${id}`),
};

export const bannersAPI = {
  list: (params) => api.get('/banners', { params }),
  create: (data) => api.post('/banners', data),
  update: (id, data) => api.put(`/banners/${id}`, data),
  delete: (id) => api.delete(`/banners/${id}`),
  trackClick: (id) => api.post(`/banners/${id}/click`),
  trackImpression: (id) => api.post(`/banners/${id}/impression`),
};

export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.post('/settings', data),
};

export const uploadAPI = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const mediaAPI = {
  list: (params) => api.get('/media', { params }),
  update: (filename, data) => api.patch(`/media/${filename}`, data),
  delete: (filename) => api.delete(`/media/${filename}`),
};